import { request } from 'umi';

export async function getModulesApi(activeOnly: boolean = true) {
  return request<API.Module[]>('/module', {
    method: 'get',
    params: { active_only: activeOnly },
  });
}

export async function getModuleApi(moduleId: string) {
  return request<API.Module>(`/module/${moduleId}`, {
    method: 'get',
  });
}

export async function getCompanyModuleSubscriptionsApi(
  companyId: string,
  activeOnly: boolean = true,
) {
  if (!companyId || companyId === 'undefined') {
    return Promise.resolve([]);
  }
  return request<API.CompanyModuleSubscription[]>(`/module/company/${companyId}/subscriptions`, {
    method: 'get',
    params: { active_only: activeOnly },
  });
}

/**
 * 取得用戶在指定公司可用的模組
 */
export async function getUserAccessibleModulesApi(companyId: string) {
  if (!companyId || companyId === 'undefined') {
    return Promise.resolve([]);
  }
  return request<API.CompanyModuleSubscription[]>(`/user/accessible-modules/${companyId}`, {
    method: 'get',
  });
}
